import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { getColorVar } from '@alfa-bank/newclick-core/utils';
import cn from 'classnames';
import { Circle } from '@alfalab/core-components/icon-view/circle';
import { PureCell } from '@alfalab/core-components/pure-cell';
import { Typography } from '@alfalab/core-components/typography';
import { useMedia } from '@alfalab/hooks';
import { AlfaBankLogoMIcon } from '@alfalab/icons-logotype/AlfaBankLogoMIcon';
import { useWidgetContext } from '../../../../../hooks/use-widget-context';
import styles from './index.module.css';
export const VoipTextCallMobile = ({ text }) => {
    const { isWebview, cssVarsPrefix } = useWidgetContext();
    const backgroundColor = getColorVar({
        color: 'graphicColorAccent',
        prefix: cssVarsPrefix,
    });
    const iconColor = getColorVar({
        color: 'staticGraphicColorLight',
        prefix: cssVarsPrefix,
    });
    const [logoCircleSize] = useMedia([
        [48, '(max-width: 359px)'],
        [64, '(min-width: 360px)'],
    ], 64);
    const [paddingTop] = useMedia([[true, '(min-width: 360px) and (max-width: 389px)']], false);
    return (_jsxs(PureCell, { className: cn({ [styles.pureCell]: paddingTop || isWebview }), dataTestId: 'pure-cell', children: [_jsx(PureCell.Content, { children: _jsxs(PureCell.Main, { children: [_jsx(Typography.TitleMobile, { view: 'xsmall', tag: 'div', children: "\u0410\u043B\u044C\u0444\u0430-\u0411\u0430\u043D\u043A" }), _jsx(Typography.Text, { view: 'primary-small', tag: 'div', children: text })] }) }), _jsx(PureCell.Graphics, { children: _jsx(Circle, { size: isWebview ? 64 : logoCircleSize, backgroundColor: backgroundColor, children: _jsx(AlfaBankLogoMIcon, { color: iconColor }) }) })] }));
};
